import type { Moment } from "moment";

import { baseService } from "cortex/ui/src/service/base";

export const reportingService = {
  uptime(networkId: number, start: Moment | string, end: Moment | string) {
    return baseService.post("/api/report/uptime", {
      network_id: networkId,
      start: start,
      end: end,
    });
  },

  uptimeDevices(networkId: number, date: Moment | string) {
    return baseService.post("/api/report/uptime/devices", {
      network_id: networkId,
      date: date,
    });
  },

  uptimeDevice(deviceId: string, start: Moment | string, end: Moment | string) {
    return baseService.post("/api/report/uptime/device", {
      device_id: deviceId,
      start: start,
      end: end,
    });
  },
};

export default reportingService;
